const RUN_SPEED_MULT = 2.2;

function pickRunDirection(ctx) {
  const pos = ctx.movement.getPosition();
  const vp = ctx.environment.getViewport();
  const petCenter = pos.x + (ctx.config.size || 48) / 2;
  const w = vp.width;

  if (petCenter < w * 0.12) return 1;
  if (petCenter > w * 0.88) return -1;
  return Math.random() < 0.5 ? -1 : 1;
}

export const run = {
  id: 'run',
  state: 'run',
  system: false,

  enter(ctx) {
    ctx.walkDir = pickRunDirection(ctx);
    ctx.movement.setSpeedMultiplier(RUN_SPEED_MULT);
    ctx.movement.walkTo(ctx.walkDir);
    ctx.stateTimer = ctx.getStateDuration('run');
  },

  update(ctx, dt) {
    if (!ctx.movement.isGrounded()) {
      ctx.transition('fall');
      return;
    }
    if (ctx.movement.isAtEdge() || ctx.movement.isAtViewportEdge()) {
      ctx.transition('idle');
      return;
    }
    ctx.movement.walkTo(ctx.walkDir);
    ctx.stateTimer -= dt;
    if (ctx.stateTimer <= 0) ctx.transitionToNext();
  },

  exit(ctx) {
    ctx.movement.stopWalk();
    ctx.movement.setSpeedMultiplier(1);
  },
};
